import React from "react";
import { Alert } from "antd";

const AlertAntd = (props) => {
  const { message, type } = props;
  return <AlertAntd message={message} type={type} showIcon />;
};

export default Alert;
